import React, { useState } from "react";
import ReactStars from "react-rating-stars-component";
import PropTypes from "prop-types";
import { Button } from "shards-react";

function Rating(props) {
  const { title, onFinish, size, stars, text } = props;
  const [review, setReview] = useState({
    stars: stars,
    text: text,
  });
  const previusStars = stars;
  return (
    <>
      <p className="m-0 text-center" style={{ fontSize: "16px" }}>
        {review.stars && review.stars === previusStars
          ? "Caso mudar de opinião você pode avaliar novamente!"
          : title}
      </p>

      <>
        <ReactStars
          size={size}
          value={review.stars}
          edit={true}
          onChange={(value) => {
            const r = { ...review, stars: value };
            setReview(r);
          }}
        />
        <p
          className="m-0 d-flex flex-column text-center"
          style={{ color: "#9ea8b9" }}
        >
          {!review.stars || review.stars !== previusStars
            ? "Escolha de 1 a 5 estrelas para classificar"
            : ""}
        </p>
      </>
      {review.stars && review.stars !== previusStars ? (
        <>
          <textarea
            value={review.text}
            onChange={(e) => {
              setReview({ ...review, text: e.target.value });
            }}
            rows="4"
            className="form-control mt-2 fade-in"
            placeholder="Se quiser, deixe-nos uma mensagem..."
          />
          <Button
            className="mt-2 mb-5"
            onClick={() => {
              onFinish(review);
            }}
          >
            Enviar
          </Button>
        </>
      ) : null}
    </>
  );
}

Rating.propTypes = {
  text: PropTypes.string,
  onChange: PropTypes.func,
  stars: PropTypes.number,
  reviewText: PropTypes.string,
  size: PropTypes.number,
};

export default Rating;
